export const workOrderPublicBtn = {
  data() {
    return {
      
    }
  },
  methods: {
    // 删除
    deleteOrder:function(code,id){
      this.showDeletePop = true;
      
      this.deleteId = id;
    },
    // 删除
    batchDeleteOrder:function(code,param,deleteStyle,reason){
    
      let journalType= "";
      let menuId= "";
      let url = "workOrder/doLogicDelete.json";
      switch(code){
        case 'b_2':
          journalType = "工单管理=>所有工单=>";
          menuId = "b_2-6";
          break;
        case 'b_3':
          journalType = "工单管理=>我的未完成工单=>";
          menuId = "b_3-2";
          break;  
        case 'b_4':
          journalType = "工单管理=>待我确认的工单=>";
          menuId = "b_4-2";
          break;
        case 'b_5':
          journalType = "工单管理=>抄送给我的工单=>";
          menuId = "b_5-2";
          break;
        case 'b_6':
          journalType = "工单管理=>我创建的工单=>";
          menuId = "b_6-2";
          break;
        case 'b_7':
          journalType = "工单管理=>未分配的工单=>";
          menuId = "b_7-2";
          break;
        case 'b_8':
          journalType = "工单管理=>已分配的工单=>";
          menuId = "b_8-2";
          break;
        case 'b_9':
          journalType = "工单管理=>处理中的工单=>";
          menuId = "b_9-2";
          break;
        case 'b_a':
          journalType = "工单管理=>暂停的工单=>";
          menuId = "b_a-2";
          break;
        case 'b_b':
          journalType = "工单管理=>已完成的工单=>";
          menuId = "b_b-2";
          break;
        case 'b_c':
          journalType = "工单管理=>已关闭的工单=>";
          menuId = "b_c-2";
          break;
        
      }
      if(deleteStyle == '0'){  //选中结果
        param = {
          journalType:  journalType+param.journalType,
          menuId: menuId,
          ids: param.id,
          type:deleteStyle,
          deleteReason: reason,
        };
      }else if(deleteStyle == '1'){  //搜索
        this.$set(param, 'menuId', menuId);
        this.$set(param, 'type', deleteStyle);
        this.$set(param, 'deleteReason', reason);
      }
      let that = this;
      this.$Modal.confirm({
        title: '提示',
        content: "是否确定删除工单",
        onOk: () => {
          that.$http.post(url,param) .then(function (res) {
            let result = res.data.flag;
            if(result!="666"){
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            that.$Message.info("删除成功");
            that.initSearch();
          });
        }
      });
    },
    // 批量操作
    batchOperate:function(code){
      this.showTitlePop = true;
    },
    // 删除事件
    closeOrderDeletePop:function(flag,id,code,reason){
      this.menuCode = code;
      this.showDeletePop=false;
      if (flag) {
          let journalType= "";
          let menuId= "";
          let url="workOrder/doLogicDelete.json";
          
          switch(code){
            case 'b_2':
              journalType = "工单管理=>所有工单=>删除";
              menuId = "b_2-6";
              break;
            case 'b_3':
              
              journalType = "工单管理=>我的未完成工单=>删除";
              menuId = "b_3-2";
              break;  
            case 'b_4':
              
              journalType = "工单管理=>待我确认的工单=>删除";
              menuId = "b_4-2";
              break;
            case 'b_5':
              
              journalType = "工单管理=>抄送给我的工单=>删除";
              menuId = "b_5-2";
              break;
            case 'b_6':
              
              journalType = "工单管理=>我创建的工单=>删除";
              menuId = "b_6-2";
              break;
            case 'b_7':
              
              journalType = "工单管理=>未分配的工单=>删除";
              menuId = "b_7-2";
              break;
            case 'b_8':
              
              journalType = "工单管理=>已分配的工单=>删除";
              menuId = "b_8-2";
              break;
            case 'b_9':
              
              journalType = "工单管理=>处理中的工单=>删除";
              menuId = "b_9-2";
              break;
            case 'b_a':
              
              journalType = "工单管理=>暂停的工单=>删除";
              menuId = "b_a-2";
              break;
            case 'b_b':
              
              journalType = "工单管理=>已完成的工单=>删除";
              menuId = "b_b-2";
              break;
            case 'b_c':
              
              journalType = "工单管理=>已关闭的工单=>删除";
              menuId = "b_c-2";
              break;
            case 'b_d':
              journalType = "工单管理=>回收站=>删除";
              menuId = "b_d-2";
              url="workOrder/doPhysicsDelete.json";
              break;
          }

          let param = {
            journalType: journalType,
            menuId: menuId,
            ids: id,
            type:'0',
            deleteReason:reason,
          };
        let that=this;
        
        this.$http.post(url,param) .then(function (res) {
              let result = res.data.flag;
              if(result!="666"){
                that.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定'
                });
                return false;
              }
              that.$Message.info("删除成功");
              that.initSearch();
            });
          } 
      
    },
    // 批量删除事件
    closeOrderPop:function(flag,deleteStyle,menucode,reason){
      this.showTitlePop=false;
      this.menuCode = menucode;
      if (flag) {
        let param={};
        if (deleteStyle=='0'){//选中结果删除
          if (this.checkIds.length==0){
            let content = "当前无可删除的工单";
            if(menucode == 'b_d'){
              content = "当前无可还原的工单";
            }

            this.$Modal.info({
              title:'提示',
              content: content
            });
            return false;
          }
          let journal = this.journalType+"按选中结果删除";
          if(menucode == 'b_d'){
            journal = this.journalType+"按选中结果还原";
          }

          param = {
            id:this.checkIds.toString(),
            journalType:journal,
            menuId:menucode
          };
        }
        if (deleteStyle=='1'){//搜索结果删除
        
          if(this.contentList.length==0){
            let content = "当前无可删除的工单";
            if(menucode == 'b_d'){
              content = "当前无可还原的工单";
            }
            this.$Modal.info({
              title:'提示',
              content:content,
            });
            return false;
          }
          if(!this.queryParam){
            this.$Modal.info({
              title:'提示',
              content:menucode == 'b_d' ? '请点击查询后再还原' : '请点击查询后再删除',
            });
            return false;
          }
          
          let journal = this.journalType+"按搜索结果删除";
          if(menucode == 'b_d'){
            journal = this.journalType+"按搜索结果还原";
          }

          delete this.queryParam["pageNum"];
          delete this.queryParam["pageSize"];
  
          this.$set(this.queryParam, 'menuId', menucode);
          this.$set(this.queryParam, 'journalType', journal);
          if (!this.deleteUrl) {
            this.$set(this.queryParam, 'operateType', 'delete');
          }
          param = this.queryParam;
        }
        this.operateOrder(menucode,param,deleteStyle,reason)
      }
    },
    
    // 导出事件
    closeExportOrderPop:function(flag,deleteStyle,menucode){
      this.showExportPop=false;
      this.menuCode = menucode;
      
      if (flag) {
        
        let param={};
        if (deleteStyle=='0'){//选中结果
          if (this.checkIds.length==0){
            this.$Modal.info({
              title:'提示',
              content: "当前无可导出的工单"
            });
            return false;
          }

          param = {
            id:this.checkIds.toString(),
            journalType: "按选中结果导出",
          };
        }
        if (deleteStyle=='1'){//搜索结果删除
        
          if(this.contentList.length==0){
            this.$Modal.info({
              title:'提示',
              content:"当前无可导出的工单",
            });
            return false;
          }
          if(!this.queryParam){
            this.$Modal.info({
              title:'提示',
              content:"请点击查询后再导出"
            });
            return false;
          }
          delete this.queryParam["pageNum"];
          delete this.queryParam["pageSize"];
          this.$set(this.queryParam, 'journalType',"按搜索结果导出");
          this.$set(this.queryParam, 'menuId', this.menuId);
          param=this.queryParam;
         
        }
        this.$Loading.start();
        this.batchExportOrder(menucode,param,deleteStyle);
        
      }
    },

    operateOrder:function(menucode,param,deleteStyle,reason){
      if(menucode == 'b_d'){  //批量还原
        this.batchRestoreOrder(param,deleteStyle);
      }else{  //批量删除
        this.batchDeleteOrder(menucode,param,deleteStyle,reason);
      }
    },
    // 还原
    restoreOrder: function(id){
      let param = {
        journalType: "工单管理=>回收站=>还原",
        menuId: "b_d-1",
        ids: id,
        type:'0',
      };
      let that = this;
      this.$Modal.confirm({
        title: '提示',
        content: "是否确定还原工单",
        onOk: () => {
          that.$http.post("workOrder/doRecovery.json",param) .then(function (res) {
            let result = res.data.flag;
            if(result!="666"){
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            that.$Message.info("还原成功");
            that.initSearch();
          });
        }
      });
    },
    // 批量还原
    batchRestoreOrder:function(param,deleteStyle){
      if(deleteStyle == '0'){  //选中结果
        param = {
          journalType:  "工单管理=>回收站=>"+param.journalType,
          menuId: "b_d-3",
          ids: param.id,
          type:deleteStyle,
        };
      }else if(deleteStyle == '1'){  //搜索
        this.$set(param, 'menuId', "b_d-3");
        this.$set(param, 'type', deleteStyle);
      }
      let that = this;
      this.$Modal.confirm({
        title: '提示',
        content: "是否确定还原工单",
        onOk: () => {
          that.$http.post("workOrder/doRecovery.json",param) .then(function (res) {
            let result = res.data.flag;
            if(result!="666"){
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            that.$Message.info("还原成功");
            that.initSearch();
          });
        }
      });
    },

    exportOrder:function(menucode){
      this.showExportPop=true;
      this.menuCode = menucode;
    },
    // 批量导出
    batchExportOrder:function(code,param,deleteStyle){
    
      let journalType= "";
      let menuId= "";
      let orderViewName = "";
      
      switch(code){
        case 'b_2':
          journalType = "工单管理=>所有工单=>";
          menuId = "b_2-3";
          orderViewName = "所有工单";
          break;
        case 'b_3':
          journalType = "工单管理=>我的未完成工单=>";
          menuId = "b_3-1";
          orderViewName = "我的未完成工单";
          break;  
        case 'b_4':
          journalType = "工单管理=>待我确认的工单=>";
          menuId = "b_4-1";
          orderViewName = "待我确认的工单";
          break;
        case 'b_5':
          journalType = "工单管理=>抄送给我的工单=>";
          menuId = "b_5-1";
          orderViewName = "抄送给我的工单";
          break;
        case 'b_6':
          journalType = "工单管理=>我创建的工单=>";
          menuId = "b_6-1";
          orderViewName = "我创建的工单";
          break;
        case 'b_7':
          journalType = "工单管理=>未分配的工单=>";
          menuId = "b_7-1";
          orderViewName = "未分配的工单";
          break;
        case 'b_8':
          journalType = "工单管理=>已分配的工单=>";
          menuId = "b_8-1";
          orderViewName = "已分配的工单";
          break;
        case 'b_9':
          journalType = "工单管理=>处理中的工单=>";
          menuId = "b_9-1";
          orderViewName = "处理中的工单";
          break;
        case 'b_a':
          journalType = "工单管理=>暂停的工单=>";
          menuId = "b_a-1";
          orderViewName = "暂停的工单";
          break;
        case 'b_b':
          journalType = "工单管理=>已完成的工单=>";
          menuId = "b_b-1";
          orderViewName = "已完成的工单";
          break;
        case 'b_c':
          journalType = "工单管理=>已关闭的工单=>";
          menuId = "b_c-1";
          orderViewName = "已关闭的工单";
          break;
        case 'b_d':
          journalType = "工单管理=>回收站=>";
          menuId = "b_d-5";
          orderViewName = "回收站";
          break;
      }
      if(deleteStyle == '0'){  //选中结果
        param = {
          journalType:  journalType+param.journalType,
          menuId: menuId,
          ids: param.id,
          type:deleteStyle,
        };
      }else if(deleteStyle == '1'){  //搜索
        this.$set(param, 'menuId', menuId);
        this.$set(param, 'journalType', journalType+param.journalType);
        this.$set(param, 'type', deleteStyle);
      }
      this.$set(param, 'orderViewName', orderViewName);
      
      let that=this;
      let xmlResQuest = new XMLHttpRequest();
      xmlResQuest.open("POST", this.baseURL+"workOrder/exportWorkOrder.json", true);
      xmlResQuest.setRequestHeader("Content-type", "application/json");
      xmlResQuest.setRequestHeader("Authorization", "Bearer "+localStorage.getItem("token"));
      xmlResQuest.responseType = "blob";
      xmlResQuest.send(JSON.stringify(param));
      xmlResQuest.onload = function () {
        if (this.status== 200 || this.status==666) {// 判断请求状态码，看请求是否成功执行
          let content = xmlResQuest.response;
          let eLink = document.createElement('a');
          eLink.download = decodeURI(xmlResQuest.getResponseHeader("filename"));
          eLink.style.display = 'none';
          let blob = new Blob([content]);
          eLink.href = URL.createObjectURL(blob);
          document.body.appendChild(eLink);
          eLink.click();
          document.body.removeChild(eLink);
          that.$Loading.finish();
          return false;
        }
        that.$Loading.error();
        that.$Modal.info({
          title: '提示',
          content: "导出失败"
        });
      };
    },
    orderReset () {
      let searchList=this.formValidate.searchList;
      let seniorList=this.formValidate.seniorList;
      for (let i=0;i<searchList.length;i++){
        let type=searchList[i].type;
        if(type=='cascade'){
          this.formValidate.searchList[i].customValue=[];
        }else {
          this.formValidate.searchList[i].customValue="";
        }
      }
      for (let j=0;j<seniorList.length;j++){
        let type=seniorList[j].type;
        if(type=='cascade'){
          this.formValidate.seniorList[j].customValue=[];
        }else {
          this.formValidate.seniorList[j].customValue="";
        }
      }
    },
    // 回收站中批量删除单独写出
    batchDelete:function(){
      this.showRecycleDeletePop = true;
    },
    // 回收站批量删除事件
    closeRecycleOrderDeletePop:function(flag,deleteStyle){
      this.showRecycleDeletePop=false;
      if (flag) {
        let param={};
          if(deleteStyle == '0'){  //选中结果
            if (this.checkIds.length==0){
              let content = "当前无可删除的工单";
              this.$Modal.info({
                title:'提示',
                content: content
              });
              return false;
            }

            param = {
              journalType: "工单管理=>回收站=>按选中结果删除",
              menuId: "b_d-4",
              ids: this.checkIds.toString(),
              type:deleteStyle,
            };
          }else if(deleteStyle == '1'){  //搜索
            if(this.contentList.length==0){
              let content = "当前无可删除的工单";
              this.$Modal.info({
                title:'提示',
                content:content,
              });
              return false;
            }
            if(!this.queryParam){
              
              this.$Modal.info({
                title:'提示',
                content:'请点击查询后再删除',
              });
              return false;
            }
            delete this.queryParam["pageNum"];
            delete this.queryParam["pageSize"];

            this.$set(this.queryParam, 'journalType', '工单管理=>回收站=>按搜索结果删除');
            this.$set(this.queryParam, 'menuId', 'b_d-4');
            this.$set(this.queryParam, 'type', deleteStyle);
            param = this.queryParam;
          }
          let that = this;
          this.$Modal.confirm({
            title: '提示',
            content: "是否确定删除工单",
            onOk: () => {
              that.$http.post("workOrder/doPhysicsDelete.json",param) .then(function (res) {
                let result = res.data.flag;
                if(result!="666"){
                  that.$alert(res.data.msg, '提示', {
                    confirmButtonText: '确定'
                  });
                  return false;
                }
                that.$Message.info("删除成功");
                that.initSearch();
              });
            }
          });
      }
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/js/WorkOrderPublicBtn.js